<template>
  <div>
    <header-admin :active-section="12" />

    <div class="mt-3">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <router-link
            active-class="active"
            class="nav-link"
            to="/admin/cdr/flags"
          >
            {{ trans("admin.cdr.flags") }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            active-class="active"
            class="nav-link"
            to="/admin/cdr/audit-log"
          >
            {{ trans("admin.cdr.auditLog") }}
          </router-link>
        </li>
      </ul>
    </div>

    <router-view class="tab-content" />
  </div>
</template>

<script>
import HeaderAdmin from "../Header.vue";

export default {
  components: {
    HeaderAdmin,
  },
};
</script>
